import { isStrongPassword } from "../../utils/passwordPolicy";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateClientAdminDraft(draft) {
  const errors = {};
  const clientName = String(draft.clientDisplayName || "").trim();
  const adminName = String(draft.adminName || "").trim();
  const email = String(draft.adminEmail || "").trim();
  const password = String(draft.adminPassword || "");

  if (!clientName) errors.clientDisplayName = "Client display name is required.";
  else if (clientName.length > 100) errors.clientDisplayName = "Use 100 characters or fewer.";
  if (!adminName) errors.adminName = "Admin name is required.";
  else if (adminName.length > 100) errors.adminName = "Use 100 characters or fewer.";
  if (!email) errors.adminEmail = "Admin email is required.";
  else if (email.length > 100 || !EMAIL_PATTERN.test(email)) errors.adminEmail = "Enter a valid email address.";
  if (!password) errors.adminPassword = "Admin password is required.";
  else if (password.length > 256 || !isStrongPassword(password)) {
    errors.adminPassword = "Password does not meet the required policy.";
  }
  if (String(draft.confirmPassword || "") !== password) {
    errors.confirmPassword = "Passwords do not match.";
  }
  return errors;
}

export function validateLlmDraft(draft) {
  const errors = {};
  if (draft.provider !== "groq") return errors;
  const name = String(draft.groqName || "").trim();
  const key = String(draft.groqApiKey || "").trim();
  if (!name) errors.groqName = "Groq display name is required.";
  else if (name.length > 255) errors.groqName = "Use 255 characters or fewer.";
  if (!key) errors.groqApiKey = "Groq API key is required.";
  else if (key.length > 512) errors.groqApiKey = "Use 512 characters or fewer.";
  return errors;
}

export function buildOnboardingPayload(client, llm) {
  const payload = {
    client_display_name: client.clientDisplayName.trim(),
    first_admin: {
      name: client.adminName.trim(),
      email: client.adminEmail.trim(),
      password: client.adminPassword,
    },
    llm_provider: llm.provider,
  };
  if (llm.provider === "groq" && llm.groqName && llm.groqApiKey) {
    payload.groq = {
      name: llm.groqName.trim(),
      api_key: llm.groqApiKey.trim(),
    };
  }
  return payload;
}

export function validateAdminMaintenance(draft, original) {
  const errors = {};
  const name = String(draft.name || "").trim();
  const email = String(draft.email || "").trim();
  const password = String(draft.password || "");
  if (!name || name.length > 100) errors.name = "Enter a name using 100 characters or fewer.";
  if (!email || email.length > 100 || !EMAIL_PATTERN.test(email)) errors.email = "Enter a valid email address.";
  if (password && (password.length > 256 || !isStrongPassword(password))) {
    errors.password = "Password does not meet the required policy.";
  }
  if (password && draft.confirmPassword !== password) errors.confirmPassword = "Passwords do not match.";
  if (!password && draft.confirmPassword) errors.confirmPassword = "Enter a new password first.";
  const changed = name !== original.name || email !== original.email || Boolean(password);
  return { errors, changed };
}

export function firstIncompleteTab(status) {
  if (!status?.steps?.client || !status?.steps?.first_admin) return "client-admin";
  return "llm";
}
